export default __webpack_public_path__ + "static/media/spinner-illustration-world.c9014089.svg";